module.exports = "//public.getcloudapp.com/packs/media/images/plus-d2618faaf03f210ce85d470b90a8bcf6.svg";